export function CoreCommitments() {
  return (
    <div className="mt-16 text-left">
      <h2 className="text-2xl font-bold text-gray-900 mb-5">
        Our Core Commitments
      </h2>
      <ol className="list-decimal list-inside space-y-4 text-gray-700">
        <li>
          <strong className="text-lg text-gray-700">Education First</strong>
          <p className="ml-5 text-lg text-gray-700">
            AI should only be used where there is a clear and demonstrable
            benefit to teaching and learning.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Student Safety and Privacy</strong>
          <p className="ml-5 text-lg text-gray-700">
            Student data protection, security and regulatory compliance are
            non-negotiable foundations.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Ethical and Transparent Use</strong>
          <p className="ml-5 text-lg text-gray-700">
            AI systems must be understandable, accountable and free from hidden
            automation or opaque decision-making.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Designed with Educators, Experts and Students</strong>
          <p className="ml-5 text-lg text-gray-700">
            High Impact Class is developed in collaboration with teachers,
            education experts and students to reflect real classroom practice.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Instruction Remains Teacher Led</strong>
          <p className="ml-5 text-lg text-gray-700">
            AI provides insight. Teachers retain full professional authority over
            instructional decisions.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">AI as Preparation, Not Replacement</strong>
          <p className="ml-5 text-lg text-gray-700">
            AI supports learning before class so that classroom time remains a
            deeply human, teacher-led experience.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Preventing Cognitive Offloading</strong>
          <p className="ml-5 text-lg text-gray-700">
            AI must strengthen thinking, not replace it. Students remain
            responsible for articulating understanding and engaging in
            effortful learning.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Strengthening the Teacher Student Relationship</strong>
          <p className="ml-5 text-lg text-gray-700">
            Insight enhances connection. Better readiness information allows
            more responsive teaching and deeper dialogue.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Maximising the Value of Classroom Time</strong>
          <p className="ml-5 text-lg text-gray-700">
            Class time is prioritised for explicit teaching, differentiated
            instruction, rich discussion and higher-order thinking, where
            teacher expertise has the greatest impact.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Facilitating Deep Learning</strong>
          <p className="ml-7 text-lg text-gray-700">
            AI should increase cognitive demand, conceptual clarity and
            intellectual challenge.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Reducing Preparation Burden for Teachers</strong>
          <p className="ml-7 text-lg text-gray-700">
            Efficiency gains free teachers to invest more time in feedback,
            differentiation and student support.
          </p>
        </li>
        <li>
          <strong className="text-lg text-gray-700">Evidence Aligned and Pedagogically Grounded</strong>
          <p className="ml-7 text-lg text-gray-700">
            Design decisions are informed by learning science and sound teaching
            practice, not novelty or technological enthusiasm.
          </p>
        </li>
      </ol>
      <p className="mt-8 text-lg text-gray-700">
        High Impact Class is being developed by the education team at Pascal
        Press, one of Australia’s leading educational publishers for over 35
        years.
      </p>
    </div>
  );
}
